import * as React from 'react';
import * as styles from "../../messages/panels/Panel.css";
import { inject, observer } from 'mobx-react';
import { IAPanel } from '../../panels/Panel';
import { IAChoiceGroup } from '../../choiceGroup/ChoiceGroup';
import { IADateAndTimePicker } from '../../dateAndTimePicker/DateAndTimePicker';
import { IAIcon } from '../../icon/Icon';
import { LocalizationService } from '../../../services/LocalizationService';
import { IATreeview } from '../../treeview/Treeview';
import { ITreeViewItem } from '../../../interfaces/ITreeViewItem';
import { ContentOrganizerGovernanceStore } from '../store/ContentOrganizerGovernanceStore';

export interface IFilterPanelProps {
  contentOrganizerGovernanceStore?: ContentOrganizerGovernanceStore;
  clearFiltersKey?: string;
  reloadContent: () => void;
}

export interface IFilterPanelState {
  contentResponsibleExpand: boolean;
  statusExpand: boolean;
  dateExpand: boolean;
  instancesExpand: boolean;
}

@inject('contentOrganizerGovernanceStore')
@observer
export class FilterPanel extends React.Component<IFilterPanelProps, IFilterPanelState> {

  constructor(props: IFilterPanelProps) {
    super(props);
    this.state = {
      statusExpand: true,
      contentResponsibleExpand: false,
      dateExpand: true,
      instancesExpand: false,
    };
    this.loadCategories();
  }

  private loadCategories(): void {
    this.props.contentOrganizerGovernanceStore.availableCategoriesForComponent = [
      { id: "overdue", title: "Overdue", checked: false, children: undefined, showIcon: true, iconOption: { title: "Calendar", color: "red", size: 18 }, name: "overdue", guid: "overdue" },
      { id: "close", title: "Close", checked: false, children: undefined, showIcon: true, iconOption: { title: "Calendar", color: "orange", size: 18 }, name: "close", guid: "close" },
      { id: "clear", title: "Clear", checked: false, children: undefined, showIcon: true, iconOption: { title: "Calendar", color: "green", size: 18 }, name: "clear", guid: "clear" },
    ];
  }

  public render(): JSX.Element {
    let content = (
      <div>
        <div className={'RevisionDateState'}>
          <div className={styles.IA_expandHeader}
            onClick={() => {
              this.setState({ statusExpand: !this.state.statusExpand });
            }}
          >
            <div
              className={styles.IA_expandButton}
              style={{
                color: this.props.contentOrganizerGovernanceStore.highlightColor
              }}
            >
              <IAIcon
                url={this.state.statusExpand ? "https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Down/SVG/ic_fluent_chevron_down_48_regular.svg" : "https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Up/SVG/ic_fluent_chevron_up_48_regular.svg"}
                size={18}
                color={"#767676"}
              />
            </div>
            <div className={styles.IA_filterTitle}>
              {new LocalizationService().strings.ContentOrganizerGovernance_FilterPanel_State}
            </div>
          </div>
          {this.state.statusExpand &&
            <div className={styles.IA_viewPanelContentWrapper}>
              {this.props.contentOrganizerGovernanceStore.availableCategoriesForComponent &&
                <IATreeview
                  highlightColor={this.props.contentOrganizerGovernanceStore.highlightColor}
                  actionType={"Checkbox"}
                  expanded={false}
                  structureType={"Folder"} //  Arrow
                  onChange={(items: ITreeViewItem[]) => {
                    this.props.contentOrganizerGovernanceStore.filterData.selectedRevisionDateStatus = [];
                    items.forEach((item: ITreeViewItem) => {
                      if (item.checked) {
                        this.props.contentOrganizerGovernanceStore.filterData.selectedRevisionDateStatus.push({
                          id: item.guid,
                          name: item.name
                        })
                      }
                    });
                    setTimeout(() => {
                      this.props.contentOrganizerGovernanceStore.pageNumber = 1;
                      this.props.contentOrganizerGovernanceStore.filterData.isFiltered = true;
                      this.props.contentOrganizerGovernanceStore.updateFilter(this.props.contentOrganizerGovernanceStore.filterData);
                      this.props.reloadContent();
                    }, 1000);
                  }}
                  items={this.props.contentOrganizerGovernanceStore.availableCategoriesForComponent}
                />
              }
            </div>
          }
        </div>

        <div className={styles.IA_filterPanelSpace} />

        <div className={"ContentOrganizerInstance"}>
          <div className={styles.IA_expandHeader}
            onClick={() => {
              this.setState({ instancesExpand: !this.state.instancesExpand });
            }}
          >
            <div
              className={styles.IA_expandButton}
              style={{
                color: this.props.contentOrganizerGovernanceStore.highlightColor
              }}
            >
              <IAIcon
                url={this.state.instancesExpand ? "https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Down/SVG/ic_fluent_chevron_down_48_regular.svg" : "https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Up/SVG/ic_fluent_chevron_up_48_regular.svg"}
                size={18}
                color={"#767676"}
              />
            </div>
            <div className={styles.IA_filterTitle}>
              {new LocalizationService().strings.ContentOrganizerGovernance_FilterPanel_ContentOrganizer}

            </div>
          </div>
          {this.state.instancesExpand &&
            <div className={styles.IA_viewPanelContentWrapper}>
              <IATreeview
                highlightColor={this.props.contentOrganizerGovernanceStore.highlightColor}
                actionType="Checkbox"
                expanded={false}
                structureType="Folder" //  Arrow
                onChange={(items: ITreeViewItem[]) => {
                  this.props.contentOrganizerGovernanceStore.filterData.selectedContentOrganizerInstance = [];
                  items.forEach((item: ITreeViewItem) => {
                    if (item.checked) {
                      this.props.contentOrganizerGovernanceStore.filterData.selectedContentOrganizerInstance.push({
                        id: item.guid,
                        name: item.name
                      })
                    }
                  });
                  setTimeout(() => {
                    this.props.contentOrganizerGovernanceStore.pageNumber = 1;
                    this.props.contentOrganizerGovernanceStore.filterData.isFiltered = true;
                    this.props.contentOrganizerGovernanceStore.updateFilter(this.props.contentOrganizerGovernanceStore.filterData);
                    this.props.reloadContent();
                  }, 1000);
                }}
                items={this.props.contentOrganizerGovernanceStore.availableContentOrganizerInstancesForFiltering}
              />
            </div>
          }
        </div>

        <div className={styles.IA_filterPanelSpace} />

        <div className={"ModifiedDate"}>
          <div className={styles.IA_expandHeader}
            onClick={() => {
              this.setState({ dateExpand: !this.state.dateExpand });
            }}
          >
            <div
              className={styles.IA_expandButton}
              style={{
                color: this.props.contentOrganizerGovernanceStore.highlightColor
              }}
            >
              <IAIcon
                url={this.state.dateExpand ? "https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Down/SVG/ic_fluent_chevron_down_48_regular.svg" : "https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Up/SVG/ic_fluent_chevron_up_48_regular.svg"}
                size={18}
                color={"#767676"}
              />
            </div>
            <div className={styles.IA_filterTitle}>
              {new LocalizationService().strings.ContentOrganizerGovernance_FilterPanel_ModifiedDate}

            </div>
          </div>
          {this.state.dateExpand &&
            <div className={styles.IA_viewPanelContentWrapper}>
              <IAChoiceGroup
                className={styles.IA_defaultChoiceGroup}
                selectedKey={this.props.contentOrganizerGovernanceStore.filterData.showPeriod}
                highlightColor={this.props.contentOrganizerGovernanceStore.highlightColor}
                options={[
                  {
                    key: 'All time',
                    text: new LocalizationService().strings.Messages_FilterPanel_AllTime,
                    disabled: false
                  },
                  {
                    key: 'Period',
                    text: new LocalizationService().strings.Messages_FilterPanel_Period,
                    disabled: false
                  }
                ]}
                required={true}
                onChange={(key) => {
                  let filterData = this.props.contentOrganizerGovernanceStore.filterData;
                  filterData.showPeriod = key;
                  filterData.isFiltered = true;
                  this.props.contentOrganizerGovernanceStore.pageNumber = 1;
                  this.props.contentOrganizerGovernanceStore.updateFilter(filterData);
                  this.props.reloadContent();
                }}
                style={{
                  marginTop: 10
                }}
              />
              <IADateAndTimePicker
                label={new LocalizationService().strings.Messages_FilterPanel_StartTime}
                selectedDate={this.props.contentOrganizerGovernanceStore.filterData.startDate}
                showTimeSelector={true}
                highlightColor={this.props.contentOrganizerGovernanceStore.highlightColor}
                isClearable={true}
                disabled={this.props.contentOrganizerGovernanceStore.filterData.showPeriod === "All time"}
                onChange={(startDate: Date) => {
                  setTimeout(() => {
                    let filterData = this.props.contentOrganizerGovernanceStore.filterData;
                    filterData.startDate = startDate;
                    filterData.isFiltered = true;
                    filterData.showPeriod = 'Period';
                    this.props.contentOrganizerGovernanceStore.pageNumber = 1;
                    this.props.contentOrganizerGovernanceStore.updateFilter(filterData);
                    this.props.reloadContent();
                  }, 1000);

                }}
                style={{
                  marginTop: 0,
                  width: 200,
                  // opacity: 0.5
                }}
              />
              <IADateAndTimePicker
                label={new LocalizationService().strings.Messages_FilterPanel_EndTime}
                selectedDate={this.props.contentOrganizerGovernanceStore.filterData.endDate}
                showTimeSelector={true}
                highlightColor={this.props.contentOrganizerGovernanceStore.highlightColor}
                isClearable={true}
                disabled={this.props.contentOrganizerGovernanceStore.filterData.showPeriod === "All time"}
                onChange={(endDate: Date) => {
                  let filterData = this.props.contentOrganizerGovernanceStore.filterData;
                  filterData.endDate = endDate;
                  filterData.isFiltered = true;
                  filterData.showPeriod = 'Period';
                  this.props.contentOrganizerGovernanceStore.pageNumber = 1;
                  this.props.contentOrganizerGovernanceStore.updateFilter(filterData);
                  this.props.reloadContent();
                }}
                style={{
                  marginTop: 10,
                  marginBottom: 10,
                  width: 200,
                  // opacity: 0.5
                }}
              />
            </div>
          }
        </div>

        <div className={styles.IA_filterPanelSpace} />

        <div className={"ContentResponsible"}>
          <div className={styles.IA_expandHeader}
            onClick={() => {
              this.setState({ contentResponsibleExpand: !this.state.contentResponsibleExpand });
            }}
          >
            <div
              className={styles.IA_expandButton}
              style={{
                color: this.props.contentOrganizerGovernanceStore.highlightColor
              }}
            >
              <IAIcon
                url={this.state.contentResponsibleExpand ? "https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Down/SVG/ic_fluent_chevron_down_48_regular.svg" : "https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Up/SVG/ic_fluent_chevron_up_48_regular.svg"}
                size={18}
                color={"#767676"}
              />
            </div>
            <div className={styles.IA_filterTitle}>
              {new LocalizationService().strings.ContentOrganizerGovernance_FilterPanel_ContentResponsible}
            </div>
          </div>
          {this.state.contentResponsibleExpand &&
            <div className={styles.IA_viewPanelContentWrapper}>
              <IATreeview
                highlightColor={this.props.contentOrganizerGovernanceStore.highlightColor}
                actionType="Checkbox"
                expanded={false}
                structureType="Folder" //  Arrow
                onChange={(items: ITreeViewItem[]) => {
                  this.props.contentOrganizerGovernanceStore.filterData.selectedContentResponsible = [];
                  items.forEach((item: ITreeViewItem) => {
                    if (item.checked) {
                      this.props.contentOrganizerGovernanceStore.filterData.selectedContentResponsible.push({
                        id: item.guid,
                        name: item.name
                      })
                    }
                  });
                  setTimeout(() => {
                    this.props.contentOrganizerGovernanceStore.pageNumber = 1;
                    this.props.contentOrganizerGovernanceStore.filterData.isFiltered = true;
                    this.props.contentOrganizerGovernanceStore.updateFilter(this.props.contentOrganizerGovernanceStore.filterData);
                    this.props.reloadContent();
                  }, 1000);
                }}
                items={this.props.contentOrganizerGovernanceStore.availableContentResponsibleForFiltering}
              />
            </div>
          }
        </div>

        <div className={styles.IA_filterPanelSpace} />

      </div>
    );
    let top = 0;
    // if (!this.props.contentOrganizerGovernanceStore.inTeams && (Helper.getDisplayEnvironment() === "Sharepoint" || Helper.getDisplayEnvironment() === "SharepointClassic") && document.getElementById("IA_navigator_bar") && !document.getElementById("IA_navigator_vertical_menu") && !this.props.contentOrganizerGovernanceStore.isMobile) {
    //   top = 88;
    // }
    // if (!this.props.contentOrganizerGovernanceStore.inTeams && (Helper.getDisplayEnvironment() === "Sharepoint" || Helper.getDisplayEnvironment() === "SharepointClassic") && document.getElementById("IA_navigator_vertical_menu") && !this.props.contentOrganizerGovernanceStore.isMobile) {
    //   top = 48;
    // }
    // if (this.props.contentOrganizerGovernanceStore.inTeams && document.getElementById("IA_navigator_bar") && !document.getElementById("IA_navigator_vertical_menu") && !this.props.contentOrganizerGovernanceStore.isMobile) {
    //   top = 40;
    // }
    // if (this.props.contentOrganizerGovernanceStore.isAdminPage && location.href.indexOf("intraactive-admin") !== -1) {
    // top = 109;
    // }
    // if (this.props.contentOrganizerGovernanceStore.isMobileApp) {
    //   top = Helper.isIPhoneXType() ? 90 : 70;
    // }
    return (
      <IAPanel
        showNavigationBar={true}
        open={this.props.contentOrganizerGovernanceStore.showFilterPanel != undefined && this.props.contentOrganizerGovernanceStore.showFilterPanel}
        transition={this.props.contentOrganizerGovernanceStore.panelIsOpen ? "fade" : "slide"}
        width={this.props.contentOrganizerGovernanceStore.isMobile ? window.innerWidth : 400}
        isMobile={false}
        highlightColor={this.props.contentOrganizerGovernanceStore.highlightColor}
        marginTop={top}
        close={() => {
          this.props.contentOrganizerGovernanceStore.showFilterPanel = false;
        }}
        onClearFilters={() => {
          this.props.contentOrganizerGovernanceStore.availableContentResponsibleForFiltering.map((resp) =>  resp.checked = false);
          this.props.contentOrganizerGovernanceStore.availableContentOrganizerInstancesForFiltering.map((resp) =>  resp.checked = false);

          this.props.contentOrganizerGovernanceStore.updateFilter({
            isFiltered: false,
            showPeriod: "All time",
            selectedContentOrganizerInstance: [],
            selectedContentResponsible: [],
            selectedRevisionDateStatus: [],
            startDate: undefined,
            endDate: undefined
          });
          
          this.loadCategories();
          this.props.reloadContent();
        }}
      >{content}</IAPanel>
    );
  }
}